/**
 * Marketo Forms
 *
 * This file loops through all the Marketo Forms that are loaded on a page,
 * Forms are built using ACF Blocks to select options for the form,
 * such as button style, column layout, extra classes
 */

const loadForms2Script = () => {
    if (window.forms2Loaded) {
        return;
    }
    window.forms2Loaded = true;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = '//info.packetfabric.com/js/forms2/js/forms2.min.js';
    script.onload = () => {
        init();
    };
    document.head.appendChild(script);
};

/**
 * Delay loading forms2.min.js until interaction or timeout
 */
document.addEventListener('DOMContentLoaded', () => setTimeout(loadForms2Script, 3500));
document.addEventListener('scroll', loadForms2Script, { once: true });
document.addEventListener('mousemove', loadForms2Script, { once: true });
document.addEventListener('touchstart', loadForms2Script, { once: true });

const $ = jQuery;

window.FormsPlus = window.FormsPlus || {
    allDescriptors: {},
    allMessages: {},
    detours: {}
};

const formIds = $('form[data-formId]').map(function () {
    return parseInt(this.getAttribute('data-formId'));
}).get();
const uniqueFormIds = formIds.filter(function (item, pos) {
    return formIds.indexOf(item) === pos;
});
let isSubmittable = false;
let validRecaptcha = false;

const mktoFormConfig = {
    podId: "//info.packetfabric.com",
    munchkinId: "588-BOZ-660",
    formIds: uniqueFormIds,
    recaptcha: "6LeXNk4bAAAAAIRmWeyPBFLeEJVDCPnApk1JStyI",
    fields: {
        recaptchaFinger: 'fingerprint',
    },
    actions: {
        formSubmit: 'form'
    },
    debug: {
        testBadFinger: false
    }
};

const MKTOFORM_ID_PREFIX = 'mktoForm_',
    MKTOFORM_ID_ATTRNAME = 'data-formId';

/**
 * Initialize module code
 *
 */
const init = function (formId = null) {

    // Return early if page has no forms
    if (typeof MktoForms2 === 'undefined') {
        return;
    }

    // If passed a specific formId, only render that form
    if (formId) {
        mktoFormConfig.formIds = [formId];
    }

    mktoFormChain(mktoFormConfig);
    onFormRender();
};

function mktoFormChain(config) {

    /* util */
    var arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

    /* fix inter-form label bug! */
    MktoForms2.whenRendered(function (form) {
        const formEl = form.getFormElem()[0],
            rando = "_" + new Date().getTime() + Math.random();

        arrayFrom(formEl.querySelectorAll("label[for]")).forEach(function (labelEl) {
            var forEl = formEl.querySelector('[id="' + labelEl.htmlFor + '"]');
            if (forEl) {
                labelEl.htmlFor = forEl.id = forEl.id + rando;
            }
        });
    });

    /* chain, ensuring only one #mktoForm_nnn exists at a time */
    arrayFrom(config.formIds).forEach(function (formId) {
        var loadForm = MktoForms2.loadForm.bind(MktoForms2, config.podId, config.munchkinId, formId),
            formEls = arrayFrom(document.querySelectorAll("[" + MKTOFORM_ID_ATTRNAME + '="' + formId + '"]'));

        (function loadFormCb(formEls) {
            const formEl = formEls.shift();
            formEl.id = "mktoForm_" + formId;

            loadForm(function (form) {
                const formElm = form.getFormElem()[0];

                whenReady(form, formElm);
                onValidate(form, formElm);
                onSubmit(form, formElm);
                onSuccess(form, formElm);

                formEl.id = "";
                if (formEls.length) {
                    loadFormCb(formEls);
                }
                FormsPlus.tagWrappers();
            });
        })(formEls);
    });
}

/**
 * Functions to run when the form is Ready
 *
 * Not run during the MktoForms2.whenReady, as this fires
 * multiple times.
 *
 * @param form
 * @param formElm
 */
const whenReady = function (form, formElm) {
    destyleMktoForm(form);
    cleanUpMarkup();
    setSubmitButton(form, formElm);
    setStatus(formElm);
    setUTMParameters(form);
    maybeAddPlaceholders(form, formElm);
    setupReCAPTCHA(form, formElm);
    showForm(form, formElm);
    hideSpinner(form, formElm);
};

/**
 * Validation of the form
 *
 *
 * @var bool builtInValid If the default validation passes
 * @param form
 * @param formElm
 */
const onValidate = function (form, formElm) {

    form.onValidate(function (builtInValid) {

        clearErrors(form, formElm);

        if (!builtInValid) {
            formElm.dataset.status = 'error';
            return;
        }

        form.submittable(isSubmittable);

        if (!isSubmittable) {

            // Check if the form has recaptcha
            const formHasRecaptcha = hasRecaptcha(form, formElm);

            // Disable Inputs while processing
            updateDisabledProperty(formElm, true);
            formElm.dataset.status = 'submitting';

            // Check for valid recaptcha
            if (formHasRecaptcha && !validRecaptcha) {
                let recaptcha = validateRecaptcha(form, formElm);
                if (!recaptcha) {
                    updateDisabledProperty(formElm, false);
                    return false;
                }
            } else {
                validRecaptcha = true;
            }

            if (!validRecaptcha) {
                form.submittable(false);
                // Re-enable Inputs after error
                updateDisabledProperty(formElm, false);
                formElm.dataset.status = 'error';
                return;
            }

            isSubmittable = true;

            if (form.getId() === 1051) {
                submitDemoRequest(form)
                    .then((response) => {
                        if (response.hasOwnProperty('success') && response.success) {
                            isSubmittable = true;
                            form.submit();
                        } else {
                            if (response.hasOwnProperty('message')) {
                                form.showErrorMessage(response.message);
                            } else {
                                form.showErrorMessage('There was an error submitting your form. Please try again later.');
                            }
                        }
                    })
            }

            form.submittable(isSubmittable);
        }
    })
};

/**
 * Updates the button text during submission
 *
 * After the validation passes, the onSubmit event runs
 *
 * @param form
 * @param formElm
 */
const onSubmit = function (form, formElm) {
    form.onSubmit(function () {
        formElm.dataset.status = 'submitting';
    })
};

/**
 * Runs when Marketo returns a Success Response
 *
 * @param form
 * @param formElm
 */
const onSuccess = function (form, formElm) {
    form.onSuccess(function () {

        // Fire GTM Event Tracking
        fireAnalyticsTracking(form, formElm);

        // If gated, save the post id to the cookie
        if (formElm.dataset.formtype === 'gated') {
            saveSubmittedForm(formElm);
        }

        if (formElm.dataset.successtype === 'thank-you-page') {

            // Redirect to thank you page
            // @TODO Maybe hardcode backup url in case of bad value in form
            window.location = formElm.dataset.thankyoupageurl;

        } else {
            // Show the Success Message
            const successMessage = formElm.parentElement.querySelector('#success-message');
        }

        return false;
    })
};

/**
 * Fires GTM Event Tracking
 *
 * @param form
 * @param formElm
 */
const fireAnalyticsTracking = function (form, formElm) {

    const attributes = {
        eventCategory: formElm.getAttribute('data-eventCategory'),
        eventAction: formElm.getAttribute('data-eventAction'),
        eventLabel: formElm.getAttribute('data-eventLabel'),
        eventValue: formElm.getAttribute('data-eventValue'),
    };

    // For GTM tracking

    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            'event': 'marketoFormClick',
            'marketoEventCategory': attributes.eventCategory,
            'marketoEventAction': attributes.eventAction,
            'marketoEventLabel': attributes.eventLabel,
            'marketoEventValue': attributes.eventValue,
        });
    }
};

/**
 * Sets the custom CTA text for the submit button
 *
 * @param form
 * @param formElm
 * @returns {boolean}
 */
const setSubmitButton = function (form, formElm) {
    let cta = formElm.getAttribute('data-submitbutton');

    if (!cta) {
        return false;
    }

    let button = $(formElm).find('button[type="submit"]');

    if (button.length > 0) {
        button[0].innerText = cta;
    }

    return true;
};

/**
 * Only add a placeholder to the Email field in the Newsletter Form
 *
 * @param form
 * @param formElm
 */
const maybeAddPlaceholders = function (form, formElm) {

    if (!formElm.classList.contains('packetfabric-form--newsletter')) {
        return;
    }

    let $email = $(formElm).find('input[name="Email"]');

    if ($email.length < 1) {
        return;
    }

    $email.attr('placeholder', $email.attr('name'));
}

/**
 * Gets the current values of the cookie
 *
 * @returns array
 */
const getSubmittedForms = function () {
    let cookie = getCookie('pf_submitted_forms');

    if (!cookie) {
        return [];
    }

    return JSON.parse(getCookie('pf_submitted_forms'));
}

/**
 * Saves the current form ID to the Submitted Forms Cookie
 *
 * Pulls down the current form ids already submitted, adds the current
 * form, then saves the cookie with a 30 day expiration.
 *
 * @param formElm
 */
const saveSubmittedForm = function (formElm) {
    let submittedForms = getSubmittedForms();
    submittedForms.push(formElm.dataset.formid);

    setCookie('pf_submitted_forms', JSON.stringify(submittedForms), 30);
}

/**
 * Gets a cookie by name
 *
 * @param name
 * @returns {string}
 */
const getCookie = function (name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
}

/**
 * Sets a cookie with an expiration in days
 *
 * @param name
 * @param value
 * @param exp
 */
const setCookie = function (name, value, exp) {
    let date = new Date();
    date.setTime(date.getTime() + (exp * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value};path=/; ${expires}`;
}


/**
 * Grab UTM Parameters from URL and add to Marketo Form hidden fields
 *
 * @param form
 */
const setUTMParameters = function (form) {

    let utmQuery = decodeURIComponent(window.location.search.substring(1)),
        utmVariables = utmQuery.split('&'),
        formParams = {},
        ParameterName,
        i;

    const utmParams = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
    ];

    const valueExists = (value) => {
        return (value != null && value !== '' && value !== undefined)
    };

    const getUTMValue = (inputParameter) => {
        for (i = 0; i < utmVariables.length; i++) {
            ParameterName = utmVariables[i].split('=');
            if (ParameterName[0] === inputParameter) {
                return ParameterName[1] === null ? null : ParameterName[1];
            }
        }
    };

    utmParams.forEach(param => {
        var pValue = getUTMValue(param);

        // The hidden field names do not include the underscore, remove that
        // while setting the formParams to update.
        if (valueExists(pValue)) {
            let inputName = param + '__c';
            formParams[inputName] = pValue;
        }
    });

    form.setValues(formParams);
};

/*
 * @author Sanford Whiteman
 * @version v1.104
 * @license MIT License: This license must appear with all reproductions of this software.
 *
 * Create a completely barebones, user-styles-only Marketo form
 * by removing inline STYLE attributes and disabling STYLE and LINK elements
 */
const destyleMktoForm = function (mktoForm, moreStyles) {
    const formEl = mktoForm.getFormElem()[0],
        arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

    // remove element styles from <form> and children
    const styledEls = arrayFrom(formEl.querySelectorAll("[style]")).concat(formEl);
    styledEls.forEach(function (el) {
        el.removeAttribute("style");
    });

    // disable remote stylesheets and local <style>s
    const styleSheets = arrayFrom(document.styleSheets);
    styleSheets.forEach(function (ss) {
        if ([mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(ss.ownerNode) !== -1 || formEl.contains(ss.ownerNode)) {
            ss.disabled = true;
        }
    });

    if (!moreStyles) {
        formEl.setAttribute("data-styles-ready", "true");
    }
};

/**
 * Removes dom elements from the embedded Marketo Form
 *
 * These deal more with the default styling, and get in the
 * way of our custom styles.
 */
const cleanUpMarkup = function () {

    const elementsToRemove = [
        '.mktoClear',
        '.mktoOffset',
        '.mktoGutter',
    ];

    elementsToRemove.forEach(el => {
        const elements = document.querySelectorAll(el);
        Array.prototype.forEach.call(elements, (node) => {
            node.parentNode.removeChild(node);
        })
    });
}

const setStatus = function (formElm) {
    formElm.dataset.status = 'loaded';
}


/**
 * Runs every time the form renders.
 *
 * Forms render when initially created and every time
 * the visibility rules alters the structure of the form.
 *
 * We need to set the row Classes when the GDPR Checkboxes
 * get added to the form for styling.
 */
const onFormRender = function () {

    if (typeof MktoForms2 === "undefined") {
        return;
    }

    MktoForms2.onFormRender(form => {
        destyleMktoForm(form);
    })
};

/**
 * Displays the hidden form with a default fade in
 */
const showForm = function (form, formElm) {
    $(formElm).css('visibility', 'visible').hide().fadeIn();
};

/**
 * Hides the loading spinner
 *
 * @param form
 */
const hideSpinner = function (form) {
    $('.js-spinner__' + form.getId()).remove();
};

/**
 * Checks if the form is using reCAPTCHA
 *
 * @param form
 * @param formElm
 * @returns {boolean}
 */
const hasRecaptcha = function (form, formElm) {
    return !!(formElm.getAttribute('data-recaptcha') &&
        formElm.getAttribute('data-recaptcha') === 'true');
}

/**
 * Validates Google reCAPTCHA
 *
 * Uses the grecaptcha functions to get the users fingerprint
 *
 * Sends the fingerprint to the rest api endpoint where it is validated on the
 * backend with the secure key.
 *
 * Repurposed from Sanford Whiteman's reCAPTCHA v3 v1.1.2 pen
 *
 * @link https://codepen.io/figureone/pen/yLgKXge?editors=0010
 * @param form
 * @param formElm
 * @returns {boolean}
 */
const validateRecaptcha = function (form, formElm) {
    form.locked = false;

    // Make sure the recaptcha script is loaded
    if (typeof grecaptcha === 'undefined') {
        displayRecaptchaErrorMessage(form, formElm);
        return false;
    }

    // Recaptcha is enabled, and is not yet valid
    grecaptcha.ready(function () {
        grecaptcha.execute(mktoFormConfig.recaptcha, {
            action: mktoFormConfig.actions.formSubmit
        })
            .then(function (recaptchaFinger) {
                var mktoFields = {};
                if (form.locked === false) {

                    form.locked = true;
                    if (!mktoFormConfig.debug.testBadFinger) {
                        mktoFields[mktoFormConfig.fields.recaptchaFinger] = recaptchaFinger;
                    } else {
                        mktoFields[mktoFormConfig.fields.recaptchaFinger] = 'known bad fingerprint ' + Math.random();
                    }
                    mktoFields.path = window.location.href;

                    $.ajax({
                        url: rbMarketoFormsObject.rest_url + 'pf/v1/validate-recaptcha',
                        method: 'POST',
                        data: mktoFields,
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
                        },
                        success: function (response) {
                            let parsed = JSON.parse(response);

                            if (parsed.success && isHumanScore(parsed.score)) {
                                validRecaptcha = true;
                                form.locked = false;
                                form.submit();
                            } else {
                                displayRecaptchaErrorMessage(form, formElm);
                                return false;
                            }
                        },
                        error: function (error) {
                            console.error(error);
                        }
                    })
                } else {
                    console.log('secondary recaptcha response resolved');
                }
            })
    })
    return false;
}

/**
 * Sends the form submission to the backend rest endpoint for Demo Requests
 *
 * @param form
 */
const submitDemoRequest = function (form) {
    return new Promise((res, rej) => {
        const values = form.vals();
        const data = JSON.stringify(values);
        let reqHeaders = new Headers();
        reqHeaders.append('Content-Type', 'text/json');

        let restRequest = new Request(rbMarketoFormsObject.rest_url + 'packetfabric/v1/demo-request', {
            method: 'POST',
            body: JSON.stringify(data),
        });

        sendToRest(restRequest)
            .then((response) => {
                return res(response.json());
            })
            .catch(error => {
                return rej(error);
            })
    })
}

/**
 * Async Function for sending a fetch to a rest endpoint
 *
 * @param request
 * @returns {Promise<Response>}
 */
let sendToRest = async function (request) {
    return await (fetch(request));
}

/**
 * Sends the email to the check-email endpoint for verification
 *
 * Depending on the form type the email domain is checked against one or more
 * lists of blocked domains.
 *
 * If successful the isSubmittable value is set to true and the form is resubmitted
 *
 * We have to resubmit because the Marketo Form does not wait for the results of
 * the ajax call.
 *
 * @param form
 * @param formElm
 */
const checkEmail = function (form, formElm) {

    const vals = form.vals(),
        data = {
            email: vals.Email,
            formId: form.getId(),
            pageId: rbMarketoFormsObject.page_id,
            blocklist: formElm.getAttribute('data-blocklist'),
        };

    $.ajax({
        url: rbMarketoFormsObject.rest_url + 'sysdig/v1/check-email',
        method: 'POST',
        async: true,
        data: data,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
        },
        success: function (response) {
            isSubmittable = true;
            form.submit();
        },
        error: function (error) {
            console.error(error);
            // var code = error.responseJSON.code;
            //
            // if ('bad-email' === code) {
            // 	displayEmailValidationError(form, error);
            // 	updateDisabledProperty(formElm, false);
            // 	formElm.dataset.status = 'error';
            // 	var submitButton = formElm.querySelector('.js-submit-text');
            // 	submitButton.innerHTML = formElm.getAttribute('data-submit-button');
            // }

            return false;
        }
    });
};

let displayReCaptchaValidationError = function (form, error) {
    let recaptchaElem = form.getFormElem().parent().find(".recaptcha-wrapper");
    $("<div class='mkto-error-row' role='alert'>Please fill out the reCAPTCHA</div>").insertAfter(recaptchaElem);
}

let clearErrors = function (form, formElm) {
    form.getFormElem().parent().find('.mkto-error-row').remove();
    form.getFormElem().parent().find('#recaptcha-row').remove();
}


/**
 * Sets the API and Recaptcha settings and elements in the form
 *
 * @param form
 * @param formElm
 */
let setupReCAPTCHA = (form, formElm) => {
    if (formElm.getAttribute('data-recaptcha') !== 'false') {
        loadReCAPTCHAScript();
        addReCAPTCHABranding(formElm);
    }
};

/**
 * Loads the google recaptcha script
 */
let loadReCAPTCHAScript = () => {
    let recaptchaLib = document.createElement('script');
    recaptchaLib.src = "https://www.google.com/recaptcha/api.js?render=" + mktoFormConfig.recaptcha + "&badge=bottomleft";
    document.head.appendChild(recaptchaLib);
}

/**
 * Adds the google recaptcha branding at the bottom of the form
 *
 * We use the invisible badge so we have to include this privacy and terms statement with the form.
 *
 * @param formElm
 */
let addReCAPTCHABranding = (formElm) => {
    let div = document.createElement('div');
    div.classList.add('recaptcha-branding', 'mt-4');
    div.innerHTML = '<p class="text-sm">This site is protected by reCAPTCHA<br>and the Google <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer noopener">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer noopener">Terms of Service</a> apply.</p>';

    formElm.appendChild(div);
}

/*! @author Sanford Whiteman @license MIT */
FormsPlus.tagWrappers = function tagWrappers() {
    /* common vars & aliases */
    var ANCESTORS_STOR = '.mktoFormRow',
        INPUTS_STOR = 'INPUT,SELECT,TEXTAREA,BUTTON',
        attrTag = 'data-wrapper-for',
        _forEach = Array.prototype.forEach;

    /* utility fn to tag wrapper containers with inner form inputs */
    function tagMktoWrappers(formEl) {
        _forEach.call(formEl.querySelectorAll(ANCESTORS_STOR), function (ancestor) {
            ancestor.setAttribute(attrTag, '');
            _forEach.call(ancestor.querySelectorAll(INPUTS_STOR), function (input) {
                var currentTag = ancestor.getAttribute(attrTag);
                ancestor.setAttribute(attrTag, [currentTag ? currentTag : '', input.name].join(' ').trim());
            });
        });
    }

    MktoForms2.whenRendered(function (form) {
        var formEl = form.getFormElem()[0];
        tagMktoWrappers(formEl);
    });

};

/**
 * Updates the disabled property
 *
 * Pass in the form and the status. True disables, False re-enables.
 *
 * @param formEl
 * @param status
 */
let updateDisabledProperty = function (formEl, status) {
    let $inputs = $(formEl).find('input');
    let $selects = $(formEl).find('select');
    let $submit = $(formEl).find('[type="submit"]');
    $inputs.each(function () {
        $(this).prop('disabled', status);
    });
    $selects.each(function () {
        $(this).prop('disabled', status);
    });
    $submit.each(function () {
        $(this).prop('disabled', status);
    })
};

/**
 * Checks the Recaptcha Score
 *
 * The success response from the recaptcha validation includes a score from 0 - 1.
 * Zero being a robot, One being a human, and the scale of confidence in between.
 *
 * We will allow anyone that is a 0.6 and above.
 *
 * Since it is difficult to compare a floating point number, it is easier to just use a
 * switch to check the individual cases to allow through. Note, a 1 is never really returned
 * but it could be so I've included it here.
 *
 * @param score
 * @returns {boolean}
 */
const isHumanScore = function (score) {
    switch (score) {
        case 1.0:
        case 0.9:
        case 0.8:
        case 0.7:
        case 0.6:
            return true;

        default:
            return false;
    }
}

/**
 *
 * @param form
 * @param formElm
 */
const displayRecaptchaErrorMessage = function (form, formElm) {
    var buttonRow = formElm.querySelector('.mktoButtonRow');
    $("<div class='alert alert-warning text-center' role='alert' id='recaptcha-row'><strong>There was an error with your recaptcha submission. Please try again later.</strong></div>").insertBefore(buttonRow);

    formElm.dataset.status = 'error';
    form.submittable(false);
}

document.addEventListener('DOMContentLoaded', () => {
    init();
})
/**
 * Custom Event Listener from Gated Forms
 *
 * A Gated Form is first checked against the users cookies to see if they have filled out the form previous.
 * If so then the Success Content is loaded. If not then the form still needs to load. Because we've missed the
 * initial listener when the DOMContentLoaded we need to run the build again, but with only the form that was just added.
 *
 * The Custom event passes in the form id with the 'detail' argument of the event.
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/Events/Creating_and_triggering_events#adding_custom_data_%E2%80%93_customevent
 */
document.addEventListener('buildForms', (e) => {
    init(e.detail);
})

/**
 * Close Marketo Form Popup
 *
 */
document.addEventListener('click', function (e) {
    if (e.target.classList.contains('btn-close-popup')) {
        const popup = e.target.closest('[data-popup="true"]');
        if (popup) {
            popup.classList.add('popup-closed');
        }
    }
});